<div class="modal-header">
    <button type="button" class="close" aria-label="Close" (click)="cancel()"><span aria-hidden="true">&times;</span></button>
    <h4 id="labelButtons">Duplicate Customer Warning</h4>
</div>
<div class="modal-body">
    <form [formGroup]="duplicateForm">
        <ng-container *ngIf="duplicateCount <= 4">
            <p><i class="beacon--count--alert">{{duplicateCount}}</i> Potential duplicate record(s) have been found.</p>
            <p>Please select from the list of options below or "Cancel" to refine the "Add Customer" details.</p>

            <p-table [value]='duplicates' *ngIf="customerType == 1">
                <ng-template pTemplate="emptymessage">
                    <tr>
                        <td [attr.colspan]="5">
                            No Records Found
                        </td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="header">
                    <tr>
                        <th class="w--icon">Select</th>
                        <th>Name</th>
                        <th>DOB</th>
                        <th>SSN</th>
                        <th>Address</th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-data>
                    <tr [pSelectableRow]="data">
                        <td><input type="radio" name="selectedCustomer" (change)="customerSelected(data.customerNumberId)" value="{{data.customerNumberId}}" /></td>
                        <td><a href="javascript:void(0)" (click)="viewCustomer(data.customerNumberId)">{{data.customerName}}</a></td>
                        <td>
                            <ng-container *ngIf="data.dateOfBirth != ''">
                                {{data.dateOfBirth | shortDate}}
                            </ng-container>
                        </td>
                        <td>
                            <ng-container *ngIf="data.ssn != ''">
                                <ng-container *ngIf="data?.ssn?.length < 5">XXX-XX-</ng-container>{{data.ssn}}
                            </ng-container>
                        </td>
                        <td>
                            <ng-container *ngIf="data.address.addressLine1 != ''">
                                <div>{{data.address.addressLine1}}</div>
                                <div>{{data.address.city}}, {{data.address.jurisdictionCode}} {{data.address.countyCode}}</div>
                            </ng-container>
                        </td>
                    </tr>
                </ng-template>
            </p-table>

            <p-table [value]="duplicates" *ngIf="customerType == 2">
                <ng-template pTemplate="emptymessage">
                    <tr>
                        <td [attr.colspan]="3">
                            No Records Found
                        </td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="header">
                    <tr>
                        <th class="w--icon">Select</th>
                        <th>Name</th>
                        <th>EIN</th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-data>
                    <tr [pSelectableRow]="data">
                        <td> <input type="radio" name="selectedCustomer" (change)="customerSelected(data.customerNumberId)" value="{{data.customerNumberId}}" /></td>
                        <td><a href="javascript:void(0)" (click)="viewCustomer(data.customerNumberId)">{{data.customerName}}</a></td>
                        <td>{{data.ein}}</td>
                    </tr>
                 </ng-template>
            </p-table>

            <div class="mvd_form-group">
                <label class="mvd_label--inline" for="radContinue">
                    <input id="radContinue" type='checkbox' name="selectedCustomer" value='continue' (change)="customerSelected(0)" /> Continue adding the customer record.
                </label>
            </div>
        </ng-container>

        <ng-container *ngIf="duplicateCount > 4">
            <p><b class="mvd_alert--label">{{duplicateCount}}</b> Potential duplicate record(s) have been found. Please add additional customer details or select to continue adding the customer record.</p>
            <div class="mvd_form-group">
                <label class="mvd_label--inline" for="radContinue">
                    <input id="radContinue" type="checkbox" (change)="customerSelected(0)" value="continue" /> Continue adding the customer record.
                </label>
            </div>
        </ng-container>
    </form>
</div>

<div class="modal-footer">
    <div class="btn--group">
        <button class="btn--default" type="button" (click)="cancel()">Cancel</button>
        <button class="btn--accent" type="submit" [disabled]="selectedCustomer == -1" (click)="continue()">Continue</button>
    </div>
</div>